(function () {
  /*========================
    Ajout d'un tag sur le module de chat
  ========================*/
  if (typeof Tawk_API != 'undefined') {
    Tawk_API.onChatMaximized = function () {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: 'gaEvent',
        eventCategory: '3-validation',
        eventAction: "besoin d'aide"
      });
    };
  }

  /*========================
    Texte por navigateur non compatible #wp-browser-update
  ========================*/
  if (typeof $buoop == 'object') {
    $buoop.text_fr =
      "Aïe ! Votre navigateur n'est pas compatible pour souscrire en ligne sur le site M comme Mutuelle. <br />Pour continuer : <a{up_but}>Télécharger un autre navigateur</a> <a{ignore_but}>Ignorer</a>";
  }
})();
